import React, { lazy, Suspense, useState } from "react";
import { Link } from "react-router-dom";
import { withLocalize } from "react-localize-redux";

import flag_GBR from "../../assets/images/flags/GBR.png";

const LanguageDialog = lazy(() => import("./LanguageDialog"));

const LanguageToggle = (props) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Link to="#" onClick={toggle} style={{ textDecoration: 'none' }}>
        <span className="f-btn f-btn-ghost" style={{ padding: '8px 14px', fontSize: '0.8rem', gap: 8 }}>
          <img src={flag_GBR} width="16" height="16" alt="" />
          EN
        </span>
      </Link>

      {modal && (
        <Suspense fallback={null}>
          <LanguageDialog
            isOpen={modal}
            toggle={toggle}
            setActiveLanguage={props.setActiveLanguage}
          />
        </Suspense>
      )}
    </>
  );
}

export default withLocalize(LanguageToggle);
